import FlexPane from 'presentation/components/flex-pane/index.js';
import Notification from 'presentation/components/notification/index.js';
import VoidReasonMessageTypes from 'presentation/components/void-reason-message/types.js';
import { useEffect } from 'react';
import MojitoCore from 'mojito/core';

const log = MojitoCore.logger.get('VoidReasonMessage');

const VoidReasonMessage = props => {
    const { reason, mojitoTools } = props;
    const { config, stringResolver } = mojitoTools;

    useEffect(() => {
        if (reason && !VoidReasonMessageTypes.VOID_REASONS[reason]) {
            log.warn(`Unknown bet void reason: ${reason}.`);
        }
    }, [reason]);

    if (!reason) {
        return null;
    }

    const voidMessage =
        stringResolver.resolveString(`$VOID_REASON_MESSAGE.VOID_REASON.${reason}`, true) ||
        stringResolver.resolveAndFormatString(`$VOID_REASON_MESSAGE.VOID_REASON.OTHER`, reason);

    return (
        <FlexPane class={'ta-VoidReasonMessage'} config={config.container}>
            <Notification text={voidMessage} config={config.notification} />
        </FlexPane>
    );
};

export default VoidReasonMessage;
